function isRouteToSales(): boolean {
    const route = `${window.location.pathname}${window.location.hash}`;

    return /^\/#?\/?((sales)|$)/gi.test(route);
}

export default isRouteToSales;
